import { ExerciseModel, ExplanationModel } from '../../interfaces/models/CardModel';

export interface AnswerModel {
    answer: string;
    index: number;
    isCorrect?: boolean;
}

export enum ExerciseType {
    exercise, explanation
}

/**
 * Adapter to work with different types of answers logic (exercise / explanation)
 */
export interface AnswersAdapter {

    type: ExerciseType;

    /**
     * Total [solutionN] placeholders
     */
    totalPlaceholders: number;

    /**
     * Formatted answers list
     */
    answers: AnswerModel[];

    /**
     * Content divided by [solutionN]
     */
    contentParts;

    /**
     * Explanation / Exercise field
     */
    field: ExplanationModel | ExerciseModel;

    /**
     * Verification of chosen answer
     *
     * @param index - current answer index
     * @param currentPlaceholderIndex - focused placeholder index
     */
    verifyAnswer(index, currentPlaceholderIndex?);

}
